import React, { useState} from 'react'
import PropTypes from 'prop-types'
import styled, { css } from "styled-components";
import { THEME } from 'Util/constants';
import { BellFilled } from '@ant-design/icons';
import CommonExportIcon from 'Components/CommonExportIcon'

const Container = styled.div`
    
    width: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .anticon{
        color: ${THEME.colors.primary};
        cursor: pointer;
    }
    
    svg{
        cursor: pointer;
    }

    `;

function ExtraFilter({data, column}) {    
    return (
        <Container>
            <CommonExportIcon data={data} columns={column}/>
        </Container>
    )
}

ExtraFilter.propTypes = {
    data: PropTypes.array,
    column: PropTypes.array
}

export default ExtraFilter
